import { render } from "./ClimateStripesTool.vue?vue&type=template&id=0199d491&scoped=true"
import script from "./ClimateStripesTool.vue?vue&type=script&lang=js"
export * from "./ClimateStripesTool.vue?vue&type=script&lang=js"

import "./ClimateStripesTool.vue?vue&type=style&index=0&id=0199d491&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0199d491"]])

export default __exports__